import type { SelectOptionElement } from '@odin-labs/components';
import { getSelectOptions } from 'components/utils';

/** Select options shared by a form and the screens that list its submissions. */
export const formSelectOptions: Record<'training', SelectOptionElement[]> = {
  // walbridge-training: the name is what an entry saves, so add trainings but never rename one
  training: getSelectOptions({
    values: [
      'SQC M1: Data Center Foundations',
      'SQC M2: LOTO & InfraLink',
      'SQC M3: LV Installation Excellence',
      'SQC M4: MV Installation Excellence',
      'SQC M5: QA/QC Inspection Excellence',
      'SQC M6: Cx & Energization Readiness',
      'SQC M7: Supervisor Leadership & Electrical Oversight',
      'SQC MECH01: Safety Excellence for the Mechanical Trades',
      'SQC MECH02: Quality Excellence for the Mechanical Trades',
    ],
    labelGetter: null,
  }),
};
